<template>
  <div class="MethodObl" :style='{ backgroundImage: `url(${card.pict_800})` }'>
    <div class="AddObl" v-if="showEditLink" @click="$refs.pict.click()">Загрузить картинку</div>
    <input type="file" ref="pict" @change="uploadPict" style="display: none" accept="image/*">
  </div>
</template>

<script>
export default {
  props: {
    card: { type: Object, default: function() { return {}; } },
    showEditLink: { type: Boolean, default: function() { return false; } },
    saveData: Function
  },
  methods: {
    uploadPict(event) {
      const selectedFile = event.target.files[0]
      console.log('uploadPict event', event)
      console.log('uploadPict selectedFile', selectedFile)
      if (selectedFile == undefined) return;

      const formData = new FormData();
      formData.append("card[pict]", selectedFile);
      console.log('formData', formData);
      this.saveData(formData, false, ['pict']);
    },
  }
};
</script>
